module.exports = __webpack_public_path__ + "static/qh_21.cbe96b12.jpg";